import { publishProductPriceChangedEvent } from '../../events/product-price-changed'
import { setCurrentVariant } from '../../store/product/actions'
import { productState } from '../../store/product/index'
import { getQueryParams } from '../../utils/url'

const variantIdFormSelector = 'form [name="id"]'

const checkVariantChange = () => {
  try {
    const val = getVariantIdFromForm()
    if (val && productState.currentVariant && val !== productState.currentVariant.id) {
      setCurrentVariant(val)
      if (productState.currentVariant) {
        publishProductPriceChangedEvent({
          price: productState.currentVariant.price
        })
      }
    }
  } catch (ex) {
    console.error('faild to act on possible variant change', ex)
  }
}

const getVariantIdFromForm = (): number | null => {
  const idElement = document.querySelector(variantIdFormSelector)
  if (idElement) {
    const id = parseInt((idElement as HTMLInputElement).value)
    if (id) {
      return id
    }
  }
  return null
}

export const getCurrentVariantId = (): number | null => {
  const queryParams = getQueryParams()
  if (queryParams.variant) {
    return parseInt(queryParams.variant)
  }
  return getVariantIdFromForm()
}

export const registerToVariantChange = () => {
  setInterval(() => {
    checkVariantChange()
  }, 500)
}
